import { useDispatch, useSelector } from 'react-redux';
import {
  fetchGetProject,
  fetchGetFieldData,
  fetchPostProject,
  fetchPutProject,
  fetchDeleteProject,
  fetchSyncProject,
  cleanUpDataFieldProject,
  cleanUpProject,
  cleanUpMessageProject
} from 'state-managament/project.slice';

export default function useProject(project) {
  const { error, success, isLoaded, data, fieldData, fieldDataConst } = useSelector((state) => state.project);
  const dispatch = useDispatch();

  const cleanUp = () => dispatch(cleanUpProject());
  const cleanUpMessage = () => dispatch(cleanUpMessageProject());
  const getFieldData = () => dispatch(fetchGetFieldData());
  const getProject = (args) => dispatch(fetchGetProject(args));
  const postProject = (args) => dispatch(fetchPostProject(args));
  const deleteProject = (args) => dispatch(fetchDeleteProject(args));
  const putProject = (args) => dispatch(fetchPutProject(args));
  const syncProject = (args) => dispatch(fetchSyncProject(args));
  const cleanUpDataField = () => dispatch(cleanUpDataFieldProject());

  return {
    error,
    success,
    isLoaded,
    data,
    fieldDataConst,
    fieldData,
    cleanUp,
    cleanUpMessage,
    getFieldData,
    getProject,
    postProject,
    deleteProject,
    putProject,
    syncProject,
    cleanUpDataField
  };

}
